import React from "react";
import { TableCell, TableSortLabel } from "@mui/material";

const SortableTableCell = ({
  label,
  sortKey,
  sortConfig,
  requestSort,
  align = "left",
}) => {
  const isActive = sortConfig?.key === sortKey;
  const direction = isActive ? sortConfig.direction : "asc";

  return (
    <TableCell align={align}>
      <TableSortLabel
        active={isActive}
        direction={direction}
        onClick={() => requestSort(sortKey)}
        sx={{
          "& .MuiTableSortLabel-icon": {
            opacity: isActive ? 1 : 0.3,
          },
        }}
      >
        <b>{label}</b>
      </TableSortLabel>
    </TableCell>
  );
};

export default SortableTableCell;
